import { render, staticRenderFns } from "./LFilterSection.vue?vue&type=template&id=2d4cb394&scoped=true"
import script from "./LFilterSection.vue?vue&type=script&lang=js"
export * from "./LFilterSection.vue?vue&type=script&lang=js"
import style0 from "./LFilterSection.vue?vue&type=style&index=0&id=2d4cb394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4cb394",
  null
  
)

export default component.exports